// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"libs_restaurant-kiosk-web-app-service-zone_src_index_ts":"46c00fd2930cac13","libs_shared-client-menu-cart_src_index_ts":"89f2ed131d25a1e6"}[chunkId] + ".js";
};